import { InjectionToken } from '@angular/core';
import { DatastoreConfig } from './datastore.interface';

export const DATASTORE_CONFIG = new InjectionToken<DatastoreConfig>(
  'DatastoreConfig',
);



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-webapp-compat/webapp/src/app/@shared/datastore/datastore.config.ts